import { formatStatus } from "component/MarketPlace/OrderRequestDetail/utils";
import { PRE_JOINER_STATUS, STATUS_COLORS, STATUS_TEXT } from "../constant";
import { green, red } from '@mui/material/colors';

type ColorsMUI = 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | undefined;
type StatusColor = {
    color: string;
    backgroundColor: string;
    type: ColorsMUI
}
const colors: Record<string, StatusColor> = {
    default: { color: 'text.secondary', backgroundColor: '#00000014', type: 'default' },
    error: { color: 'error.main', backgroundColor: red[50], type: 'error' },
    success: { color: 'success.main', backgroundColor: green[50], type: 'success' },
  };
  
  export const getColors = (status: PRE_JOINER_STATUS) => {
    if (STATUS_COLORS.ERROR.includes(status)) {
      return colors.error;
    }
  
    if (STATUS_COLORS.SUCCESS.includes(status)) {
      return colors.success;
    }
  
    if (STATUS_COLORS.DEFAULT.includes(status)) {
      return colors.default;
    }
  
    return colors.default;
  };
  
  export const mapOrderStatus = (status: PRE_JOINER_STATUS) => {
    const statusText = STATUS_TEXT[status] || formatStatus(status);
    const statusColors = getColors(status);
    return { statusText, statusColors };
  };